import React from "react";
import Styles from "./index.module.scss";
import { Button } from "antd";
import { EvaCourseListItem } from "../../../Service";
import classNames from "classnames";
import { isTrue } from "../../../../../service/service";
import { useHistory } from "react-router-dom";
import useModalHandler from "../../../../../utils/v3/useModalHandler";
import CurrentTimeModal from "./Components/CurrentTimeModal";

interface Props {
    item: EvaCourseListItem;
}
const Index = ({ item }: Props) => {
    const history = useHistory();
    function navTo() {
        history.push(`/my/detail/${item.evaluationId}`);
    }

    const modal = useModalHandler({
        component: CurrentTimeModal
    });

    function openModal() {
        modal.open({
            name: item.courseName
        });
    }

    return (
        <div className={Styles.root}>
            <div className={Styles.content}>
                <div className={Styles.title}>{item.courseName}</div>
                <p className={Styles.info}>
                    课程编号：{item.courseNo} - 课序号：{item.courseSeq}
                </p>
                <p className={Styles.info}>
                    授课教师：{item.teacherName}({item.teacherNo})
                </p>
                <span
                    className={classNames(Styles.status, {
                        [Styles.statusNone]: isTrue(item.flag)
                    })}>
                    {isTrue(item.flag) ? "已评价" : "待评价"}
                </span>
            </div>
            <div className={Styles.footer}>
                <Button
                    size="small"
                    icon="star"
                    ghost
                    type="primary"
                    onClick={navTo}>
                    评价
                </Button>
                <Button
                    size="small"
                    icon="table"
                    ghost
                    type="primary"
                    onClick={openModal}>
                    查看上课时间表
                </Button>
            </div>

            {modal.render()}
        </div>
    );
};

export default Index;
